import { hosts } from 'config';
import { BaseClient } from 'clients/BaseClient/BaseClient';
import { convertKeysToSnakeCase, formatQueryParams } from 'utils/shared';
import type {
  GetBatchConversationsHandler,
  GetConversationsHandler,
  GetConversationsPreviewHandler,
  GetUnreadConversationsAmountHandler,
} from './ConversationsClient.types';

export class ConversationsClient extends BaseClient {
  getConversations: GetConversationsHandler = (params) => {
    const formattedParams = formatQueryParams(convertKeysToSnakeCase(params));
    return this.request({
      url: `${hosts.notificationsApi()}/conversations/${formattedParams}`,
      method: 'GET',
    });
  };

  getConversationsPreview: GetConversationsPreviewHandler = () => {
    return this.request({
      url: `${hosts.notificationsApi()}/conversations/preview/`,
      method: 'GET',
    });
  };

  getUnreadConversationsAmount: GetUnreadConversationsAmountHandler = (params) => {
    const formattedParams = formatQueryParams(convertKeysToSnakeCase(params));
    return this.request({
      url: `${hosts.notificationsApi()}/conversations/unread/${formattedParams}`,
      method: 'GET',
    });
  };

  getBatchConversationsBasedOnEsPersonIds: GetBatchConversationsHandler = (esPersonIds) => {
    return this.request({
      url: `${hosts.notificationsApi()}/conversations/batch_conversations_based_on_es_person_ids/`,
      method: 'POST',
      data: {
        es_person_ids: esPersonIds,
      },
    });
  };
}

export const conversationsClient = new ConversationsClient();
